import '../styles/components/info-display.css';

const InfoDisplay = ({ label, value, className = '' }) => {
  return (
    <div className={`info-row ${className}`}>
      <p className="info-label">{label}</p>
      <p className="info-value">{value}</p>
    </div>
  );
};

export default InfoDisplay;